import React from "react";
import "./Hero.css";
import { motion } from "framer-motion";
import { FaArrowRight } from "react-icons/fa";
import heroBg from "../../assets/hero-bg.jpg";
import { useLanguage } from "../../context/LanguageContext"; // 1. Import

const Hero = () => {
  const { t } = useLanguage(); // 2. Récupération des traductions

  return (
    <section
      className="hero-container"
      id="hero"
      style={{ backgroundImage: `url(${heroBg})` }}
    >
      <div className="hero-overlay"></div>

      <div className="hero-content">
        <motion.h1
          className="hero-title"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          {/* 3. Utilisation des textes traduits */}
          {t.hero.titleLine1} <br />
          <span className="text-gold">{t.hero.titleLine2}</span>
        </motion.h1>

        <motion.p
          className="hero-subtitle"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          {t.hero.subtitle}
        </motion.p>

        <motion.div
          className="hero-buttons"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <a href="#contact" className="btn btn-primary">
            {t.hero.ctaPrimary} <FaArrowRight />
          </a>
          <a href="#services" className="btn btn-outline">
            {t.hero.ctaSecondary}
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
